import { __awaiter, __generator, __rest, __spreadArray } from "tslib";
import platformApi from "@/platform/index";
import { LOCAL_WEBP_MARK, V2_MARK, CATCH_ERROR_MARK, STATIC_FORMATS } from "@/const/index";
import { getFileSuffix, addParamToURL, urlParams2Object } from "./index";
import { parseUrlParams } from "./config";
import { arrayIncludesPolyfill, objectAssignPolyfill } from "./es5Tool";
import { getGlobalConfig } from "./globalConfig";
var webpSupportCache = null;
export var setWebpSupportCache = function (value) {
    webpSupportCache = value;
};
// 判断本地是否支持webp标识，可能标识并未更新，通过 setWebpSupportMark 更新标识
export var useMarkCheckWebpSupport = function () {
    // 内存webp标识
    if (webpSupportCache !== null)
        return webpSupportCache;
    // 本地webp标识
    var localWebp = platformApi.getStorage(LOCAL_WEBP_MARK);
    if (localWebp != undefined) {
        return (webpSupportCache = localWebp === "1");
    }
    return false;
};
// 生成数据万象参数
export var genFormatCI = function (data) {
    if (data === void 0) { data = {}; }
    var _a = data.type, type = _a === void 0 ? 2 : _a, config = __rest(data, ["type"]);
    var keys = Object.keys(config);
    if (!keys.length) {
        return "";
    }
    var ci = "".concat(V2_MARK, "/").concat(type);
    keys.forEach(function (key) {
        if (arrayIncludesPolyfill(["w", 'h', 'q', 'format'], key)) {
            // @ts-ignore
            ci += "/".concat(key, "/").concat(config[key]);
        }
    });
    ci += CATCH_ERROR_MARK;
    return encodeURI(ci);
};
// 调整 config 的格式转换逻辑
export var adjustConfigForFormat = function (fileSuffix, config) {
    if (config === void 0) { config = {}; }
    // GIF 动态图片不能转成静态格式
    if (fileSuffix === "gif" &&
        config.format &&
        arrayIncludesPolyfill(STATIC_FORMATS, config.format)) {
        delete config.format;
    }
    // 如果浏览器不支持 WebP，删除 WebP 格式配置
    if (config.format === "webp") {
        var supportWebp = useMarkCheckWebpSupport();
        !supportWebp && delete config.format;
    }
    return config;
};
// 生成格式化后图片链接
export var genFormatUrl = function (url, _config) {
    var _a, _b;
    if (_config === void 0) { _config = {}; }
    var config = objectAssignPolyfill({}, _config);
    var _c = url.split("?"), _url = _c[0], params = _c.slice(1);
    // url参数
    var urlParamsString = __spreadArray([], params, true).join('?');
    var fileSuffix = getFileSuffix(_url);
    // 是否为私有桶链接
    var isPrivate = !!((_a = urlParams2Object(url)) === null || _a === void 0 ? void 0 : _a.sign);
    var parseNode = parseUrlParams(_url);
    // 不处理无法替换的 URL
    if (!parseNode)
        return url;
    // 如果参数有sign说明是私有桶CDN不进行url替换 
    var replaceDomain = isPrivate ? parseNode.replace : parseNode.cdn;
    var formattedUrl = _url.replace(parseNode.replace, replaceDomain);
    if (!(config === null || config === void 0 ? void 0 : config.delUrlParams)) {
        // 保留url参数
        formattedUrl = addParamToURL(formattedUrl, urlParamsString);
    }
    else if (isPrivate) {
        // 删除url参数，但是如果是私有链接则保留私有sign参数
        formattedUrl = addParamToURL(formattedUrl, "sign=".concat((_b = urlParams2Object(url)) === null || _b === void 0 ? void 0 : _b.sign));
    }
    if (config.forceNoWebp && config.format === "webp") {
        // 强制删除webp参数
        delete config.format;
    }
    // svg文件只进行cdn替换,不添加CI参数
    if (fileSuffix === "svg")
        return formattedUrl;
    adjustConfigForFormat(fileSuffix, config);
    return addParamToURL(formattedUrl, genFormatCI(config));
};
// 设置 webp 支持程度标识
export var setWebpSupportMark = function () { return __awaiter(void 0, void 0, void 0, function () {
    var webpChecker, isSupportWebp;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                webpChecker = ((_a = getGlobalConfig()) === null || _a === void 0 ? void 0 : _a.checkWebPSupport) || platformApi.checkWebp;
                return [4 /*yield*/, webpChecker()];
            case 1:
                isSupportWebp = _b.sent();
                platformApi.setStorage(LOCAL_WEBP_MARK, isSupportWebp ? "1" : "0");
                return [2 /*return*/];
        }
    });
}); };
